import $ from 'jquery'
import {
    scrollToElement
} from 'js/common/constants';
import Swal from 'sweetalert2';

export default function () {
    changeAddressType();
    paymentTabController();
    completeOrder();
    fillContracts();

    setTimeout(() => {
        $('[name=InvoiceAddress]:checked')
            .prop('checked', false)
            .click();
    }, 500);
}

function changeAddressType() {
    $('.js-change-address-type').on('change', function () {
        if (!$(this).is(':checked')) {
            $('.js-delivery-address').removeClass('d-none');
            scrollToElement('.js-delivery-address', 500);
        } else {
            $('.js-delivery-address').addClass('d-none');
        }
    })
}

function paymentTabController() {
    $('.js-select-type').on('click', function(e) {
        e.preventDefault();

        const tabType = $(this).data('tab-type');
        
        if($(this).hasClass('active'))
        {
            return;
        }

        // if(!checkUnSelectInputs())
        //     return;
        
        const requestURL = 'calculate-price';
        const selectedInvoiceAddress = $('input[name=InvoiceAddress]:checked').val();
        const selectedShippingAddress = $('input[name=ShippingAddress]:checked').val();
        const paymentTypeID = $(`[data-tab-type=${tabType}]`).find('input[name=PaymentTypeID]').val()
        const paymentTypeText = $(`[data-tab-type=${tabType}]`).find('input[name=PaymentTypeText]').val()

        $(`[data-tab-type]`).removeClass('active selected');
        $(`[data-tab-type=${tabType}]`).addClass('active selected');
        
        if(tabType == 'transfer')
        {
            return;
        }

        const formData = {
            selectedInvoiceAddress,
            selectedShippingAddress,
            paymentTypeID,
            paymentTypeText
        }

        $.ajax({
            url: requestURL,
            type: 'POST',
            data: formData,
            dataType: 'json',
            success: function (response) {
                console.log(response);
                // if (response) {
                //     if (response.IsSuccess) {
                //         Swal.fire(response.Title, response.Message, response.Class);
                //         if(PaymentTypeID == 1){
                //             setTimeout(() => {
                //                 $('#creditform').submit();
                //             }, 500);
                //         }
                //         if (response.Redirect) {
                //             setTimeout(function () {
                //                 window.location.href = response.Redirect;
                //             }, 1000)
                //         }
                //     } else {
                //         Swal.fire(response.Title, response.Message, response.Class);
                //     }
                // }
            }
        })

    })
}
 
function fillContracts() {
    $(document).on('change', '.js-select-address' , function(e){
        e.preventDefault();
        let shippingAddressID;
        const addressID = $('[name=InvoiceAddress]:checked').val();
        const userID = $('[name=UserID]').val();
        const totalAmount = $('[name=TotalAmount]').val();
        
        if($('[name=SameDeliveryAddress]').is(':checked')) {
            shippingAddressID = addressID
        }else {
            shippingAddressID = $('[name=ShippingAddress]:checked').val();  
        }
        
        const formData = {
            "UserID": userID,
            "AddressID": addressID,
            "ShippingAddressID": shippingAddressID,
            "TotalAmount": totalAmount
        }

        $.ajax({
            url: window.GLOBALS.baseLink + 'checkout/contracts',
            method: 'POST',
            data: formData,
            dataType: 'json',
            success: function(response) {
                if(response.IsSuccess)
                {
                    if($('.js-sales-contract-text').length)
                    {
                        $('.js-sales-contract-text').html(response.Content);
                    }
                }
            }
        })


    })
    // const selectedAddressId = $('')
}

function completeOrder()
{
    $('.js-complete-order').on('submit', function(e){
        e.preventDefault();
        
        if(!$(this).valid())
            return;

        const formData = new FormData($(this)[0]);
        // const paymentTypeID = $('.js-types-tab-content.active.selected').find('[name=PaymentTypeID]').val();
        // const paymentTypeText = $('.js-types-tab-content.active.selected').find('[name=PaymentTypeText]').val();
        const paymentTypeID = 1;
        const paymentTypeText = 'credit';
        const reservOrderID = $('[name=ReservOrderID]').val();
        const userID = $('[name=UserID]').val();
        const token = $('[name=_token]').val();
        const selectedAddressID = $('[name=InvoiceAddress]:checked').val();
        const sameDeliveryAddress = $('[name=SameDeliveryAddress]').is(':checked') ? 1  : 0;
        const shippingAddressID = !$('[name=SameDeliveryAddress]').is(':checked') ? $('[name=ShippingAddress]:checked').val() : $('[name=InvoiceAddress]:checked').val();

        formData.append("UserID", userID);
        formData.append("_token", token);
        formData.append("PaymentTypeID", paymentTypeID);
        formData.append("PaymentTypeText", paymentTypeText);
        formData.append("ReservOrderID", reservOrderID);
        formData.append("selectedInvoiceAddress", selectedAddressID);
        formData.append("SameDeliveryAddress", sameDeliveryAddress);
        formData.append("selectedShippingAddress", shippingAddressID);


        const requestURL = paymentTypeID == 1 ? 'calculate-price' : 'checkout/odeme';

        $.ajax({
            url: requestURL,
            type: 'POST',
            data: formData,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {
                if (response) {
                    if (response.IsSuccess) {
                        Swal.fire(response.Title, response.Message, response.Class);
                        if(paymentTypeID == 1){
                            setTimeout(() => {
                                $('#creditform').submit();
                            }, 500);
                        }
                        if (response.Redirect) {
                            setTimeout(function () {
                                window.location.href = response.Redirect;
                            }, 1000)
                        }
                    } else {
                        Swal.fire(response.Title, response.Message, response.Class);
                    }
                }
                // if (response) {
                //     if (response.IsSuccess) {
                //         Swal.fire(response.Title, response.Message, response.Class);
                //         if (response.Redirect) {
                            
                //             setTimeout(function () {
                //                 window.location.href = response.Redirect;
                //             }, 1000)
                //         }
                //     } else {
                //         Swal.fire(response.Title, response.Message, response.Class);
                //     }
                // }
            }
        })
    });
}
